<template>
    <div>
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="label">
                        Inventory, Clients & Sales Invoices
                    </span>
                    
                </p>
            </header>
            
        <section class="modal-card-body">

            <div class="row">
                <b-autocomplete 
                    expanded
                    style="width: 93%;"
                    icon="magnify" 
                    placeholder="search and find...." 
                    keep-first 
                    v-model.trim="searchQuery"
                    :data="$store.getters.getAutocompleteList"
                    :loading="false"
                    @input="loadData"
                    @keyup.native="getAsyncAutocompleteData($event, searchQuery, '/globalSearch/index.php')"
                    @select="option => result = option"
                    >

                <template slot-scope="props">
                    
                    <div v-if="props.option.source == 'inventory'">
                        
                        <div class="media">
                        <div class="media-content">
                        {{ props.option.sku }}, <b>{{ props.option.article_name }}</b>
                        <br>
                        </div>
                        </div>
                    </div>
                    
                    <div v-if="props.option.source == 'clients'">
                        <div class="media">
                            <div class="media-content">
                            {{ props.option.customer_name }}                        
                            </div>
                        </div>                        
                    </div>
                    
                    <div v-if="props.option.source == 'sales'">
                        
                        <div class="media">
                        <div class="media-content">
                        {{ props.option.invoice_number }}
                        </div>
                        </div>
                    </div>
                    
                </template>
                
            </b-autocomplete>

            </div>
            <div class="row" style="top: 50px; position: relative;" v-if="this.getResult != null">
                
                <div class="row" v-if="this.getResult.source == 'inventory'">
                    
                <div>

                    <div class="card">
                        <div class="card-header">
                            <p class="card-header-title">
                                {{getResult.sku}}: {{getResult.article_name}}
                            </p>
                            <p class="card-content label">
                                Sales @ <span v-html="formatCurrency(getResult.sales_price)"></span>/{{getResult.uom}}
                            </p>
                            
                        </div>
                        <div class="card-content">
                            <div class="content">
                                
                                <span v-for="(data, index) in $store.getters.getArticleClosingStock" :key="index">
                                    <a @click="openArticleHistory(getResult.id, getResult.sku, data.branch.id)" style="margin: 5px; position: relative;" class="tag is-dark">
                                        {{
                                            data.branch.name
                                        }}: {{data.stock[0]}} {{getResult.uom}}
                                    </a>
                                        
                                </span>
                                
                            </div>
                        </div>
                        
                    </div>

                    
                </div>       
                <div>
                    
                </div>
                </div>

                <!-- CLIENT -->

                <div class="row" v-if="this.getResult.source == 'clients'">
                    
                <div>

                    <div class="card">
                        
                        <div class="card-header">
                            <p class="card-header-title">
                                <a @click="openClient">{{this.getResult.customer_name}}</a>
                            </p>
                            <p class="card-content label" style="text-align: right;">
                                <img :src="this.getResult.image" alt="" width="25%">
                            </p>
                            
                        </div>
                        
                    </div>

                    
                </div>       
                <div>
                    
                </div>
                </div>

                <!-- INVOICE -->

                <div class="row" v-if="this.getResult.source == 'sales'">
                    
                <div>

                </div>       
                
                </div>

            </div>

            <div style="text-align: center;">

                    
                    
            <div v-if="this.getResult == null" style="height: 200px;">
                    &nbsp;
            </div>
            <div v-if="this.getResult != null" style="height: 50px;">
                    &nbsp;
            </div>
            <div style="width: 100%; text-align: center;">
                <a @click="$emit('closeModule')" 
                    class="button is-medium is-primary">
                        OK
                </a>
            </div>
            
            </div>    
            
        </section>

        </div>

        
    </div>
    
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                searchQuery: '',
                result: null,
                openArticleHistoryPopup: false,
                searchArticleHistoryCriteria: []
            }
        },
        methods: {
            openArticleHistory(articleId, sku, branch_id) {
                this.searchArticleHistoryCriteria = {
                    branches: branch_id, 
                    selected_article: articleId,
                    sku: sku,
                    from_date: this.produceSavableDate(new Date('2017-03-01')),
                    to_date: this.produceSavableDate(new Date())
                }

                this.openArticleHistoryPopup = true
            },
            loadData() {
                let result = this.getResult

                if(result != null) {
                    if(result.source == 'inventory') {
                        this.$store.dispatch('fetchClosingStock', result.id)
                    } else if(result.source == 'sales') {
                        
                        this.$store.state.salesInvoices.filterText = ''
                        this.filterText = ''
                        
                        this.$store.commit('resetSalesInvoiceForm')
                        this.$store.dispatch('fetchSalesInvoiceInfo', this.getResult.id)    
                        
                    }
                } else {
                    this.result = null
                }
                
            },
            openInvoice() {
                this.$router.push('/salesinvoices/?id='+this.getResult.id)
                this.$emit('closeModule')
            },
            openClient() {
                this.$router.push('clients/?clientId='+this.getResult.id)
                this.$emit('closeModule')
            }
        },
        computed: {
            getSearchArticleHistoryCriteria() {
                return this.searchArticleHistoryCriteria
            },
            getResult() {
                return this.result
            },
            getCanceledItems() {
                return this.$store.state.salesInvoices.props.canceled_garments
            },
            getCanceledTailoringOrders() {

                let returnData = []
                this.getWithoutWorkOrkerList.forEach(element => {

                        if(element.check) {
                            returnData.push(element.data)
                        }

                }) 
                this.getWorkOrkerList.forEach(element => {

                        if(element.check) {
                            returnData.push(element.data)
                        }

                }) 
                
                return returnData
            },
            getCancelRetailOrderList() {

                let returnData = []
                this.getRetailOrderList.forEach(element => {

                        if(element.check) {
                            returnData.push(element.data)
                        }

                }) 
                return returnData
            },
            getRetailOrderList() {
                let returnData = []
                let dataList = this.$store.state.salesInvoices.props.retail_order_list
                dataList.forEach(element => {

                    if(this.getCanceledItems.indexOf(element.id)<0) {
                        returnData.push({
                            data: element, check: false})
                    }
                    
                })
                return returnData
            },
            getTailoringOrderList() {
                let dataList = this.$store.state.salesInvoices.props.tailoring_order_list
                return dataList
            },
            getWorkOrkerList() {
                let returnData = []
                this.getInproductionList.forEach(element => {
                    this.getTailoringOrderList.forEach(element1 => {
                        if(element1.id == element.invoice_list_id) {
                            returnData.push({
                                slNo: element.invoice_sl_no+'-'+element.sl_no+''+(element.sub_sl_no>0 ? '-'+element.sub_sl_no : ''),
                                garment: element1.garment.garment_name+''+(element1.fabric.id>0 ? ' ('+element1.fabric.sku+')' : ''),
                                current_production_status: this.$t(element.current_production_status)
                            })
                        }
                    })
                })

                return returnData
            },
            getWithoutWorkOrkerList() {
                let returnData = []
                this.getTailoringOrderList.forEach(element => {
                    
                    returnData.push({data: element, check: false})
                        
                })
                return returnData
            },
            getInproductionList() {
                return this.$store.state.salesInvoices.props.garments_in_production_process
            },
        
        }
    }
</script>

<style scoped>

    .container {
        width: 30%;
        padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        background-color: #fff; 
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 400px;
    }


/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 1024px) {
    .container {
      width: 80%;
    }
    img {
      width: 70%;
    }
}

@media screen and (max-width: 300px) {
    
}

</style>



// WEBPACK FOOTER //
// src/components/SearchBox/Index.vue